<template>
    <az-container class="area-frase">
        <h3 class="area-frase__titulo">
            Você ainda não enviou proposta de preços<br>
            para nenhuma Compra Direta.
        </h3>
        <az-call-to-action @click="$emit('irParaComprasAbertas')"
                           css-class="area-frase__botao">
            Ver Compras Abertas
        </az-call-to-action>
    </az-container>
</template>

<script>
export default {
    name: 'MinhasComprasDiretasFrase'
}
</script>

<style scoped lang="stylus">
    .area-frase
        min-height 300px
        text-align center
        box-sizing border-box

        &__titulo
            color #777
            margin-bottom 20px
            padding-top 50px
            font-size 16px

        &__botao
            padding 10px 15px
            border 1px solid var(--v-primary-base)
            background-color var(--v-primary-base) !important
            color #fff !important
            box-sizing border-box
</style>